/* RSI v2 · Hvorfor – logikk fra Claude Design. Krever rsi-dc.js. */

class RSIP_hvorfor extends DCLogic {
  renderVals() {
    
    return {};
  }
}

window.RSIP_hvorfor = RSIP_hvorfor;
